import { render, staticRenderFns } from "./svgAmazonstore.vue?vue&type=template&id=21214c02"
import script from "./svgAmazonstore.vue?vue&type=script&lang=js"
export * from "./svgAmazonstore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports